import React from 'react';
import { FaChalkboardTeacher } from 'react-icons/fa';

/** Shown instead of "Enroll" for teacher accounts: only students can enroll. */
const TeacherEnrollNote = ({ compact = false }) => (
  <div
    role="note"
    data-testid="teacher-enroll-note"
    className={`flex items-center justify-center gap-2 w-full ${compact ? 'py-2.5 text-xs' : 'px-6 py-3 text-sm'} text-gray-500 bg-gray-50 border border-gray-200 rounded-xl font-medium`}
  >
    <FaChalkboardTeacher className="w-4 h-4" />
    Teacher accounts can't enroll
  </div>
);

export default TeacherEnrollNote;
